import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Autocomplete, FormField, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";

import { Mode } from "constants/enum";
import { ICodename, IDataDetailAnalysis, IErrorAnalysis } from "commons/interfaces";



export const CardIncidentGroup = ({
    mode,
    dataOptions,
    dataAnalysis,
    errorAnalysis,
    handleChangeValue,
}: {
    mode: Mode,
    errorAnalysis: IErrorAnalysis;
    dataAnalysis: IDataDetailAnalysis;
    handleChangeValue: (key: string, value: any) => void;
    dataOptions: {
        incidentType: ICodename[];
        medicineCaused: ICodename[];
        infectionCaused: ICodename[];
        misbehaveCaused: ICodename[];
        procedureCaused: ICodename[];
        managementCaused: ICodename[];
        bloodProductCaused: ICodename[];
        infrastructureCaused: ICodename[];
        patientIncidentCaused: ICodename[];
        technicalProcessCaused: ICodename[];
        medicalEquipmentCaused: ICodename[];
    };
}) => {

    const renderIncidentTypeDetail = (code: string) => {
        switch (code) {
            case "technicalProcess":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_1}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        data={dataOptions.technicalProcessCaused || []}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "infection":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.infectionCaused || []}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_2}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "medicine":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.medicineCaused || []}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_3}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "bloodProduct":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_4}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        data={dataOptions.bloodProductCaused || []}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "medicalEquipment":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_5}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        data={dataOptions.medicalEquipmentCaused || []}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "misbehave":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.misbehaveCaused || []}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_6}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "patientIncident":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_7}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        data={dataOptions.patientIncidentCaused || []}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "infrastructure":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_8}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        data={dataOptions.infrastructureCaused || []}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "management":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_9}
                        data={dataOptions.managementCaused || []}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "procedure":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.procedureCaused || []}
                        label={Strings.ANALYSIS.INCIDENT_TYPE_10}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onChange={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            case "otherGroup":
                return (
                    <FormField
                        mode={mode}
                        variant={"outlined"}
                        placeholder={Strings.COMMON.ENTER_VALUE}
                        defaultValue={dataAnalysis?.incidentTypeDetail}
                        errorMessage={errorAnalysis?.incidentTypeDetail}
                        onBlur={(value) => {
                            handleChangeValue("incidentTypeDetail", value);
                        }}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.ANALYSIS.INCIDENT_GROUP}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.incidentType}
                        label={Strings.ANALYSIS.INCIDENT_TYPE}
                        defaultValue={dataAnalysis?.incidentType}
                        errorMessage={errorAnalysis?.incidentType}
                        placeholder={Strings.ANALYSIS.SELECT_INCIDENT_TYPE}
                        onChange={(value) => {
                            handleChangeValue("incidentType", value);
                        }}
                    />
                </Grid>
                {
                    dataAnalysis?.incidentType &&
                    <Grid item xs={12} sm={6}>
                        {renderIncidentTypeDetail(dataAnalysis?.incidentType)}
                    </Grid>
                }
            </Grid>
        </Card>
    );
};

export default CardIncidentGroup;
